// react
import { useEffect, useState } from "react";

// redux
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { showAppMessage, requireAuth, showAppModal } from "~/redux/actions/app";
import {
  checkPostContactView,
  createPostContactView,
} from "~/redux/actions/post";
import { setUserInfo, resetUserInfo } from "~/redux/actions/user";

// views
import { Button, Modal } from "antd";

import { authUrlSilently, isWechatBrowser } from "~/utils/wechat";
import moment from "moment";
import { useRouter } from "next/router";

const isWechat = isWechatBrowser();

const PostContactAddon = (props) => {
  const router = useRouter();
  const [state, setState] = useState({
    submitting: false,
    viewed: null,
    contact_info: null,
    viewed_at: null,
  });

  const post = props.post;

  const postClosed = post && post.closed;
  const isJob =
    post &&
    post.category &&
    (post.category.code === "jd" || post.category.code === "talent");

  const handleCheckView = () => {
    if (!props.token) {
      return;
    }

    checkPostContactView(props.token, props.post.id)
      .then((resp) => {
        setState({ ...state, ...resp.data });
      })
      .catch((err) => {
        props.showAppMessage(err.message);
      });
  };

  const handleCreateView = () => {
    if (props.token) {
      const myEle = props.user.ele;
      if (myEle && myEle >= props.ele) {
        const title = postClosed
          ? (isJob ? "招聘已结束，" : "帖子已结束，") + "确认要查看联系方式吗？"
          : "确认要查看联系方式吗？";

        Modal.confirm({
          title,
          content: (
            <p>
              查看联系方式将消耗{" "}
              <span className="text-primary">{props.ele}</span> 电量
            </p>
          ),
          onOk() {
            setState({ ...state, submitting: true });
            createPostContactView(props.token, props.post.id)
              .then(() => {
                handleCheckView();
              })
              .catch((err) => {
                props.showAppMessage(err.message);
                setState({ ...state, submitting: false });
              });
          },
        });
      } else {
        // 当我的电量小于5时。
        Modal.confirm({
          title: "电量余额不足",
          okText: "去充电",
          closable: true,
          content: (
            <div>
              <p>哎呀，您的电量不足啦！可付费充电，支持社区发展哦：）</p>
              <p>
                <a
                  href="https://eleduck.com/posts/6GzfGe"
                  className="text-primary"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  电量的作用及如何获取电量？
                </a>
              </p>
            </div>
          ),
          onOk() {
            if (isWechat) {
              router.push({
                pathname: "/profile/info",
                query: { redirectUrl: router.asPath },
              });
            } else {
              props.showAppModal("TopUpModal");
            }
          },
        });
      }
    } else {
      props.requireAuth();
    }
  };

  useEffect(() => handleCheckView(), [props.post?.id]);

  if (props.post.contact_info === null) {
    return null;
  }

  if (state.viewed === false || !props.token) {
    return (
      <div className="text-center py-20">
        <div className="mb-10">
          <Button
            type="primary"
            disabled={state.submitting}
            onClick={handleCreateView}
          >
            {props.buttonText}
          </Button>
        </div>
        <div className="text-secondary mb-10">需消耗电量 {props.ele}</div>
      </div>
    );
  } else if (state.viewed === true) {
    return (
      <div className="py-20 text-center">
        <div className="post-contact-info">{state.contact_info}</div>
        <div className="mt-10 text-sm text-secondary">
          {/* {props.prefs.post_contact_hint} */}
          {props.isOwner
            ? "我留下的联系方式"
            : state.viewed_at
              ? `该联系方式有效期为 3 天，会在 ${moment(state.viewed_at)
                  .add(3, "days")
                  .format("YYYY 年 MM 月 DD 日 ")}后重新隐藏，请及时沟通`
              : ""}
        </div>
      </div>
    );
  } else {
    return null;
  }
};

const mapStateToProps = (state) => ({
  token: state.user.token,
  user: state.user.user,
  prefs: state.app.prefs,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      showAppMessage,
      requireAuth,
      showAppModal,
      setUserInfo,
      resetUserInfo,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(PostContactAddon);
